export default __webpack_public_path__ + "static/media/288.3f3f5687.jpg";